import req from './request.js'

export function unlockEpisode(data) {
  return req('post', '/api/pay/unlockEpisode', data)
}
// export function checkOrder(data) {
//   return req('get', '/api/pay/checkOrder', data)
// }

// export function createOrder(data) {
//   return req('post', '/api/pay/createOrder', data)
// }

// export function createBeansOrder(data) {
//   return req('post', '/api/pay/createBeansOrder', data)
// }

// export function queryBeansOrder(data) {
//   return req('get', '/api/pay/queryBeansOrder', data)
// }

// export function buy(data) {
//   return req('post', '/api/thpay/buy', data)
// }
